import template from './synonym-source-list.html.twig';
import '../../component/synonym-source-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-synonym-source-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'position',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
            importingId: null,
        };
    },

    computed: {
        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataEnhancedSearchSW6.topdata-es-synonym-source.deleteConfirmText', {
                name: this.itemToDelete.name,
            });
        },

        repository() {
            return this.repositoryFactory.create('tdes_synonym_source');
        },

        columns() {
            return [{
                property: 'name',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnName'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'language',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnLanguage'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'defaultScope',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnDefaultScope'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnActive'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'url',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnUrl'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'lastImportAt',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.columnLastImport'),
                allowResize: true,
                sortable: false,
            }];
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddSource() {
            this.currentEntity = this.repository.create();
            this.currentEntity.name = '';
            this.currentEntity.url = '';
            this.currentEntity.language = null;
            this.currentEntity.defaultScope = 'GLOBAL';
            this.currentEntity.columnTerm = 'term';
            this.currentEntity.columnSynonyms = 'synonyms';
            this.currentEntity.columnScope = null;
            this.currentEntity.columnLanguage = null;
            this.currentEntity.delimiter = ',';
            this.currentEntity.enclosure = '"';
            this.currentEntity.active = true;
            this.currentEntity.position = 0;
            this.activeModal = true;
        },

        onEditSource(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.currentEntity = null;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },

        onImport(item, dryRun) {
            this.importingId = item.id;

            const httpClient = Shopware.Application.getContainer('init').httpClient;
            httpClient.post(
                `/_action/topdata-enhanced-search-sw6/synonym-source/${item.id}/import`,
                { dryRun },
                { headers: { 'Content-Type': 'application/json' } }
            ).then((response) => {
                const data = response.data;
                const prefix = dryRun ? '[Dry run] ' : '';
                const message = `${prefix}read ${data.read}, inserted ${data.inserted}, updated ${data.updated}, merged ${data.merged}, skipped ${data.skipped}`;

                if (data.skipped > 0) {
                    this.createNotificationWarning({ message });
                } else {
                    this.createNotificationSuccess({ message });
                }

                if (!dryRun) {
                    this.getList();
                }
            }).catch((error) => {
                this.createNotificationError({
                    message: error?.response?.data?.error || error.message,
                });
            }).finally(() => {
                this.importingId = null;
            });
        },
    },
});
